
<div id="generic-dialog">
  <div  class="modal-header fechar" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div *ngIf="dialogTitle" class="dialog-title"> {{dialogTitle}} </div>
    <mat-icon class="close" aria-hidden="false" (click)="closeDialog()">clear</mat-icon>
  </div>
  <mat-dialog-content class="content-strech">
    <ng-container *ngComponentOutlet="data.component"></ng-container>
  </mat-dialog-content>
</div>